import React from 'react'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'

const PaymentLinks = () => {
  return (
    <div><ComingSoon /></div>
  )
}

export default PaymentLinks